import { logError } from './logError';

export function handleInvalidValue(value: never) {
	const error = new Error(`Unexpected value: ${value}`);

	logError(error);
}
